import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private tokenStorageService: TokenStorageService,
      private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to api url
        const token = this.tokenStorageService.getToken();
        let language = localStorage.getItem('locale');
        if (!language) {
          language = 'vi';
        }
        if (token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    'Accept-Language': language
                }
            });
        }

        return next.handle(request).pipe(
          tap(event => {},
            error => {
              if (error.status === 401) {
                sessionStorage.clear();
                localStorage.clear();
                this.router.navigateByUrl('/login');
              }
            }),
        )
    }
}
